export class ReSearchBtn {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;

    this.hideClassName = this.node.dataset.hideClass;

    this.node.addEventListener('click', () => {
      this.app.setState('isShownForm', true);

      // [todo] [ハードコーディング]
      // setStateの実行無視でviewを更新している
      // 時間がなかったごめんなさい
      this.app.spotItems.node.innerHTML = '';
      this.app.resultNoItemMsg.hide();
      this.app.resultMsg.hide();
      this.app.courseCopyBtn.hide();

      this.app.scrollAppTopLoc();
    });
  }

  show() {
    this.node.classList.remove(this.hideClassName);
  }

  hide() {
    this.node.classList.add(this.hideClassName);
  }

  render() {
    this.hide();

    if (!this.app.getState('isShownForm')) {
      this.show();
    }
  }
}
